import { ActionType, getType } from 'typesafe-actions';

import * as Action from '../actions/ConstantAction';

const defaultState = {
  businessTypes: [],
  isFetched: false,
};
export default function constant(
  state: AppConstant = defaultState,
  action: ActionType<typeof Action>
): AppConstant {
  switch (action.type) {
    case getType(Action.updateConstant):
      return { ...action.payload };
    default:
      return state;
  }
}
